import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Raven from 'raven-js';
import { HttpCssClient } from '../shared/http-request.interceptor';
import { Product } from '../models/product.model';
import { map } from 'rxjs/operators';

import { CheckAvailability } from '../models/check-availability.model';
import { Sale } from '../models/sale.model';
import { ProductSettings } from '../settings/product.settings';

import { HttpParams } from '@angular/common/http';


@Injectable()
export class ProductService{

    constructor(private http: HttpCssClient){};

    getProduct(id): Observable<Product> {
        let uri = ProductSettings.PRODUCT_DETAILS;
        uri = uri.replace(/:id/,id);
        return this.http.get(uri);
    }

    getSpotlightProduct(idLocation): Observable<Product> {
        let uri = ProductSettings.PRODUCTS_SPOTLIGHT;
        uri = uri.replace(/:id/,idLocation);
        return this.http.get(uri);
    } 

    findAllByCity(id, queryParams:Object  = null): Observable<Product[]> {
        let uri = ProductSettings.PRODUCTS_CITY;
        let urlParams = new HttpParams();
        for(let param in queryParams){
            urlParams = urlParams.set(param, queryParams[param]);
        }
        uri = uri.replace(/:id/,id);
        return this.http.get(uri, urlParams);
    }

    findTopByCity(id): Observable<Product[]> {
        let uri = ProductSettings.PRODUCTS_TOP_CITY;
        uri = uri.replace(/:id/,id);
        return this.http.get(uri);
    }

    checkAvailability(productId, check:CheckAvailability, version:string="A"):Observable<any>{
        let uri = ProductSettings.PRODUCT_DETAILS;
        uri = uri.replace(/:id/,productId);
        if(version == "B"){
            uri = uri+"?grouped=true";
        }
        //Check to register bug 20182018
        if (check != null && check['dateStr'])
        {
            try{
                let dateCheck = check['dateStr'].toString();
                let year = Number.parseInt(dateCheck.slice(0,dateCheck.indexOf('-')));
                if (isNaN(year) || year > 2024)
                {
                    throw new Error('Date too big');
                }
            }catch (e) {
                Raven.captureException( new Error('Date error on checkAvailability: ' + check['dateStr']), {
                    level: 'warning',
                    logger: 'availability'
                });
            }
        }

        return this.http.post(uri,check).pipe(map(res => res.body));
    }

    getHreflang(id): any{
        let uri = ProductSettings.PRODUCTS_HREFLANG;
        uri = uri.replace(/:id/,id);
        return this.http.get(uri)
        .pipe(map(function(response: Response){
            //TODO: Add english when it is available.
            // @ts-ignore
            let body = response.filter( elem => elem.locale === "es_ES" || elem.locale === 'en_GB');
            return body;
        }));
    }

    addToCart(sale:Sale): any{
        let uri  = ProductSettings.PRODUCT_ADD_CART;
        return this.http.post(uri,sale)
        .pipe(map((response: Response)=>{
            let token = response.headers.get("authorization");
            let body = response.body;
            if(token != null){
                this.http.addHeader("Authorization",token);
            }else{
                this.http.removeHeader("Authorization");
            }

            return <any>{response: body, token: token };
        }));
    }

    findTopProducts(continentId?:number):Observable<Product[]>{
        let url = ProductSettings.PRODUCT_TOP;
        let params = new HttpParams();
        if(continentId){params = params.set('continentId',`${continentId}`);}
        return this.http.get(url, params);
    }
}